<app-header
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<main>
    <app-policy-street-sme-banner></app-policy-street-sme-banner>
    <div
        class="tw-py-[50px] lg:tw-py-[70px] tw-px-[25px] md:tw-px-[30px] xl:tw-px-0"
    >
        <div
            class="tw-text-center md:tw-text-left tw-max-w-[1280px] tw-mx-auto"
        >
            <h3
                class="!tw-text-[#0F3172] !tw-text-[22px] md:!tw-text-[28px] !tw-font-bold"
            >
                {{
                    "INSURANCE_PAGE.POLICY_STREET.SME_PRODUCT_OVERVIEW"
                        | translate
                }}
            </h3>
            <p class="!tw-text-[#1A202C] !tw-text-[14px]">
                {{
                    "INSURANCE_PAGE.POLICY_STREET.SHARIAH_COMPLIANT" | translate
                }}
            </p>
        </div>
    </div>
    <app-policy-street-sme-services></app-policy-street-sme-services>
    <app-policy-street-sme-form
        (onSubmit)="onSubmitPolicyStreetForm($event)"
    ></app-policy-street-sme-form>
</main>
<app-footer (click)="closeMegaMenuCondition()"></app-footer>
